<template id="firstComponent">
    <div >
        <h1>I am a title.</h1>
        <p> written by {{ author }} </p>
        <div>
            <ul>
                <li v-for="list in lists">{{list}}</li>
            </ul>
        </div>
        <input v-model="addlist" type="text"/>
        <button @click='addList'>Add name</button>
        <div class="heightTest">
            <div :class="{'active':active}">
                事多了看风景是是快乐的叫法是打开了房间爱思考的了房间爱开始了的减肥快乐撒旦是电风扇的四大开发骄傲的离开奥斯卡的龙卷风埃里克束带结发思考的龙卷风
            </div>
            <button @click='changeH'>Change Height</button>
        </div>
    </div>

</template>

<script>
export default {
  data () {
      return {
          author: 'Jx',
          lists:['Jack','Rose','Tommy'],
          addlist:'',
          active:false
        }
    },
    methods:{
        addList() {
            this.lists.push(this.addlist);
            this.addlist=''
        },
        changeH() {
            this.active = true;
        }
    }

}
</script>
<!--style 添加scoped 它的 CSS 就只能作用于当前的组件  -->
<style scoped lang='scss'>
$blue : blue;

p{
    color: $blue;
}
.heightTest div {
    width:100%;
    height: 0;
    transition: all 0.5s;
    overflow: hidden;

    &.active {
        height:auto;
    }
}
</style>



// WEBPACK FOOTER //
// firstComponent.vue?710d9612